import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import Home from '@pages/Home';
import About from '@pages/About';
import Gallery from '@pages/Gallery';
import Chess from '@pages/Chess';
import Contact from '@pages/Contact';
import Robotics from '@pages/Robotics';
import Academics from '@pages/Academics';
import Sports from '@pages/Sports';
import SocialImpact from '@pages/SocialImpact';
import Experience from '@pages/Experience';
import Music from '@pages/Music';

// ScrollToTop component to handle scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/chess" element={<Chess />} />
            <Route path="/robotics" element={<Robotics />} />
            <Route path="/social-impact" element={<SocialImpact />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/music" element={<Music />} />
            <Route path="/experienceandresearch" element={<Experience />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={
              <div className="container mx-auto px-4 py-16 text-center">
                <h1 className="text-4xl font-bold mb-4">Page Coming Soon</h1>
                <p className="text-gray-600 dark:text-gray-400">
                  This page is under construction.
                </p>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
